'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ipfsUnixfsExporter = require('ipfs-unixfs-exporter');

var errCode = require('err-code');

var utils = require('../utils.js');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var cid = require('multiformats/cid');

var itTar = require('it-tar');

var itPipe = require('it-pipe');

var Pako = require('pako');

var map = require('it-map');

var toBuffer = require('it-to-buffer');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var Pako__default = /*#__PURE__*/_interopDefaultLegacy(Pako);

var map__default = /*#__PURE__*/_interopDefaultLegacy(map);

var toBuffer__default = /*#__PURE__*/_interopDefaultLegacy(toBuffer);

var DEFAULT_COMPRESSION_LEVEL = 6;

function createGet(_ref4) {
  var repo = _ref4.repo,
      preload = _ref4.preload;

  function get(_x) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ipfsPath) {
      var options,
          pathComponents,
          ipfsPathOrCid,
          file,
          args,
          _args2,
          _args5 = arguments;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};

              if (!(options.compressionLevel < 0 || options.compressionLevel > 9)) {
                _context4.next = 3;
                break;
              }

              throw errCode__default["default"](new Error('Compression level must be between 1 and 9'), 'ERR_INVALID_PARAMS');

            case 3:
              if (!(options.preload !== false)) {
                _context4.next = 12;
                break;
              }

              _context4.prev = 4;
              pathComponents = utils.normalizeCidPath(ipfsPath).split('/');
              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](4);
              throw errCode__default["default"](_context4.t0, 'ERR_INVALID_PATH');

            case 11:
              preload(cid.CID.parse(pathComponents[0]));

            case 12:
              ipfsPathOrCid = cid.CID.asCID(ipfsPath) || ipfsPath;
              _context4.next = 15;
              return _awaitAsyncGenerator(ipfsUnixfsExporter.exporter(ipfsPathOrCid, repo.blocks, options));

            case 15:
              file = _context4.sent;

              if (!(file.type === 'file' || file.type === 'raw')) {
                _context4.next = 22;
                break;
              }

              args = [];

              if (!options.compress || options.archive === true) {
                args.push([{
                  header: {
                    name: file.path,
                    mode: file.type === 'file' && file.unixfs.mode,
                    mtime: file.type === 'file' && file.unixfs.mtime ? new Date(file.unixfs.mtime.secs * 1000) : undefined,
                    size: file.size,
                    type: 'file'
                  },
                  body: file.content()
                }], itTar.pack(), function (source) {
                  return map__default["default"](source, function (buf) {
                    return buf.slice();
                  });
                });
              } else {
                args.push(file.content);
              }

              if (options.compress) {
                args.push( /*#__PURE__*/function () {
                  var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
                    var buf;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _awaitAsyncGenerator(toBuffer__default["default"](source));

                          case 2:
                            buf = _context.sent;
                            _context.next = 5;
                            return Pako__default["default"].gzip(buf, {
                              level: options.compressionLevel || DEFAULT_COMPRESSION_LEVEL
                            });

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }

              return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(itPipe.pipe.apply(itPipe, args)), _awaitAsyncGenerator), "t1", 21);

            case 21:
              return _context4.abrupt("return");

            case 22:
              if (!(file.type === 'directory')) {
                _context4.next = 30;
                break;
              }

              _args2 = [ipfsUnixfsExporter.recursive(ipfsPathOrCid, repo.blocks, options), /*#__PURE__*/function () {
                var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source) {
                  var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, output;

                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _iteratorAbruptCompletion = false;
                          _didIteratorError = false;
                          _context2.prev = 2;
                          _iterator = _asyncIterator(source);

                        case 4:
                          _context2.next = 6;
                          return _awaitAsyncGenerator(_iterator.next());

                        case 6:
                          if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                            _context2.next = 33;
                            break;
                          }

                          entry = _step.value;
                          output = {
                            header: {
                              name: entry.path,
                              size: entry.size
                            }
                          };

                          if (!(entry.type === 'file')) {
                            _context2.next = 16;
                            break;
                          }

                          output.header.type = 'file';
                          output.header.mode = entry.unixfs.mode != null ? entry.unixfs.mode : undefined;
                          output.header.mtime = entry.unixfs.mtime ? new Date(entry.unixfs.mtime.secs * 1000) : undefined;
                          output.body = entry.content();
                          _context2.next = 28;
                          break;

                        case 16:
                          if (!(entry.type === 'raw')) {
                            _context2.next = 21;
                            break;
                          }

                          output.header.type = 'file';
                          output.body = entry.content();
                          _context2.next = 28;
                          break;

                        case 21:
                          if (!(entry.type === 'directory')) {
                            _context2.next = 27;
                            break;
                          }

                          output.header.type = 'directory';
                          output.header.mode = entry.unixfs.mode != null ? entry.unixfs.mode : undefined;
                          output.header.mtime = entry.unixfs.mtime ? new Date(entry.unixfs.mtime.secs * 1000) : undefined;
                          _context2.next = 28;
                          break;

                        case 27:
                          throw errCode__default["default"](new Error('Not a UnixFS node'), 'ERR_NOT_UNIXFS');

                        case 28:
                          _context2.next = 30;
                          return output;

                        case 30:
                          _iteratorAbruptCompletion = false;
                          _context2.next = 4;
                          break;

                        case 33:
                          _context2.next = 39;
                          break;

                        case 35:
                          _context2.prev = 35;
                          _context2.t0 = _context2["catch"](2);
                          _didIteratorError = true;
                          _iteratorError = _context2.t0;

                        case 39:
                          _context2.prev = 39;
                          _context2.prev = 40;

                          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                            _context2.next = 44;
                            break;
                          }

                          _context2.next = 44;
                          return _awaitAsyncGenerator(_iterator.return());

                        case 44:
                          _context2.prev = 44;

                          if (!_didIteratorError) {
                            _context2.next = 47;
                            break;
                          }

                          throw _iteratorError;

                        case 47:
                          return _context2.finish(44);

                        case 48:
                          return _context2.finish(39);

                        case 49:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[2, 35, 39, 49], [40,, 44, 48]]);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }(), itTar.pack(), function (source) {
                return map__default["default"](source, function (buf) {
                  return buf.slice();
                });
              }];

              if (!options.compress) {
                _context4.next = 28;
                break;
              }

              if (options.archive) {
                _context4.next = 27;
                break;
              }

              throw errCode__default["default"](new Error('file is not regular'), 'ERR_INVALID_PATH');

            case 27:
              if (options.compress) {
                _args2.push( /*#__PURE__*/function () {
                  var _ref3 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(source) {
                    var buf;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return _awaitAsyncGenerator(toBuffer__default["default"](source));

                          case 2:
                            buf = _context3.sent;
                            _context3.next = 5;
                            return Pako__default["default"].gzip(buf, {
                              level: options.compressionLevel || DEFAULT_COMPRESSION_LEVEL
                            });

                          case 5:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x4) {
                    return _ref3.apply(this, arguments);
                  };
                }());
              }

            case 28:
              return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(itPipe.pipe.apply(itPipe, _args2)), _awaitAsyncGenerator), "t2", 29);

            case 29:
              return _context4.abrupt("return");

            case 30:
              throw errCode__default["default"](new Error('Not a UnixFS node'), 'ERR_NOT_UNIXFS');

            case 31:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[4, 8]]);
    }));
    return _get.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(get);
}

exports.createGet = createGet;